var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStandoutInstant(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_84682",
    "data-name": "Group 84682",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 104.25,
    height: 103,
    viewBox: "0 0 104.25 103",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24686",
    "data-name": "Rectangle 24686",
    width: 104.25,
    height: 103,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_84681",
    "data-name": "Group 84681",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_240181",
    "data-name": "Path 240181",
    d: "M88.235,68.672a15.822,15.822,0,1,0-15.8-15.844v.022a15.81,15.81,0,0,0,15.8,15.822Z",
    fill: "#ffdbb3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_240182",
    "data-name": "Path 240182",
    d: "M24.9,97.028l14.5-16.4S62.437,71.638,64.123,64.9C66.056,57.367,56.8,40.062,56.8,40.062S79.268,20.728,74.526,18.1C70.885,16.128,35.174,44.488,35.151,43.1c-.224-13.035-6.63-15.417-10.05-15.732a1.574,1.574,0,0,0-1.7,1.843,50.568,50.568,0,0,1-.7,21.957c-2.247,7.888-.966,11.731-2.247,13.125L7.261,79.436",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_240183",
    "data-name": "Path 240183",
    d: "M56.749,39.971a13.98,13.98,0,0,0-12.765,2.742c-5.956,5.079-10.226,17.305-9.529,19.35.36,1.011,1.753,1.236,3.394,1.281,0,0-2.247,5.057,2.877,5.057,0,0-1.641,2.045,1.528,3.461s15.507-4.225,15.507-4.225",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_240184",
    "data-name": "Path 240184",
    d: "M37.8,63.5c1.775-1.438,7.3-12.293,12.653-13.327",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_240185",
    "data-name": "Path 240185",
    d: "M40.725,68.4c2.652-1.169,10.024-8.316,13.125-9.327",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_240186",
    "data-name": "Path 240186",
    d: "M85.831,69.392a16.721,16.721,0,1,0-16.7-16.742v.021a16.71,16.71,0,0,0,16.7,16.721Z",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_10874",
    "data-name": "Line 10874",
    y1: 9.709,
    x2: 6.765,
    transform: "translate(50.996 7.135)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_10875",
    "data-name": "Line 10875",
    x1: 5.525,
    y1: 7.529,
    transform: "translate(27.4 11.272)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_240187",
    "data-name": "Path 240187",
    d: "M43.894.5l-.247,2.989a.539.539,0,0,0,.337.517l2.742,1.146a.539.539,0,0,1,0,1.011l-2.877.674a.516.516,0,0,0-.4.472L43.2,10.28a.517.517,0,0,1-.97.248L40.68,7.966a.539.539,0,0,0-.584-.225l-2.9.674a.517.517,0,0,1-.517-.854l1.955-2.247a.582.582,0,0,0,0-.629l-1.551-2.54a.517.517,0,0,1,.652-.764l2.743,1.147a.518.518,0,0,0,.607-.135L43.018.145a.517.517,0,0,1,.876.36Z",
    fill: "#ffdbb3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_240188",
    "data-name": "Path 240188",
    d: "M77.852,52.286l6,6L95.066,47.049",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_240189",
    "data-name": "Path 240189",
    d: "M3.282,60.807,25.06,54.694A4.5,4.5,0,0,1,30.5,57.5L41.736,88.967a4.5,4.5,0,0,1-2.711,5.75l-.008,0-22.272,7.956a4.5,4.5,0,0,1-5.74-2.748c-.013-.035-.024-.07-.036-.106L.226,66.538a4.494,4.494,0,0,1,2.868-5.673c.062-.021.125-.04.189-.058Z",
    fill: "#fd930d"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStandoutInstant);
export default __webpack_public_path__ + "static/media/standoutInstant.f2b0f645d54cd6eabba88ee895d265ad.svg";
export { ForwardRef as ReactComponent };